import PictureRetina from '../../general/picture-fill/picture-fill';
import styles from './index.module.scss';
import classNames from 'classnames';
import { sanitizeHtml } from '../../../helpers/sanitize';

export type DescriptionsItem = {
  id?: string;
  title: string;
  description?: string;
  image?: {
    url: string;
  };
};

export type DescriptionsProps = {
  items: Array<DescriptionsItem>;
  isHorizontal?: boolean;
  isHtml?: boolean;
};

const Descriptions = ({
  items = [],
  isHorizontal = false,
  isHtml,
}: DescriptionsProps) => (
  <div
    className={classNames(
      isHorizontal && 'flexbox-space-between flexbox-wrap',
      styles['container'],
    )}
  >
    {items.map(
      ({ id, title, description, image }: DescriptionsItem, i: number) => (
        <div
          key={id || i}
          className={classNames(
            styles.wrapper,
            isHorizontal && styles['wrapper-horizontal'],
          )}
        >
          {title && (
            <h2 className={styles.title}>
              {title.replace(/<(?:.|\n)*?>/gm, '')}
            </h2>
          )}
          {description &&
            (isHtml ? (
              <p
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(description) }}
              />
            ) : (
              <p className={styles.description}>{description}</p>
            ))}
          {image && image.url && (
            <PictureRetina imgStyle={{ width: '100%' }} url={image.url} />
          )}
        </div>
      ),
    )}
  </div>
);

export default Descriptions;
